import ApiGateway from "../../aws/api-gateway/ApiGateway";
/** returns items of type within distance units from origin postiion, consumers should ensure query is iterated if LastEvaluatedKey is set  */
export const getProximateItems = async (params) => {
    const path = '/query/proximateItems';
    const res = (await ApiGateway.post(path, params, 'ConsumerApi'));
    return res;
};
